import axios, { AxiosInstance } from 'axios';
import axiosInstance from '../initializers/axios';
import { ApiConstants } from '../constants/ApiConstants';
import { toAbsoluteApiUrl } from './fileUrl';

export type EntityFileMetadata = {
  id: number;
  entityId: number;
  entityType: number;
  fileName?: string | null;
  created?: string;
};

export const loadEntityGalleryMap = async (
  entityIds: number[],
  entityType: number,
  takePerEntity = 5,
  client: AxiosInstance = axiosInstance,
) => {
  const safeIds = Array.from(new Set((entityIds || []).map(Number).filter((id) => id > 0)));
  if (!safeIds.length) return {} as Record<number, EntityFileMetadata[]>;

  const response = await client.post<EntityFileMetadata[]>(ApiConstants.file.metadataByEntityIds, {
    entityType,
    entityIds: safeIds,
    takePerEntity,
  });

  return (response.data || []).reduce<Record<number, EntityFileMetadata[]>>((acc, item) => {
    const entityId = Number(item?.entityId ?? 0);
    if (!entityId) return acc;
    if (!acc[entityId]) acc[entityId] = [];
    acc[entityId].push(item);
    return acc;
  }, {});
};

export const getMetadataFileUrl = (metadataId?: number | null) =>
  metadataId ? toAbsoluteApiUrl(ApiConstants.file.downloadByIdUrl(metadataId)) : '';

export const createPublicGalleryClient = () =>
  axios.create({
    baseURL: process.env.REACT_APP_API_URL,
  });
